<template>
  <div>
    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>EZ ADAS</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <div v-if="tab === 0" style="width: 300px;">
          <v-text-field
            placeholder="filter fixture serial number"
            single-line
            v-model="filterSerialNumber"
            append-icon="filter_list"
            class="mt-4 mr-3"
          >
          </v-text-field>
        </div>

        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab @click="refreshTab('fixtures')">Fixtures</v-tab>
            <v-tab @click="refreshTab('targets')">Targets</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <Fixtures :filterSerialNumber=filterSerialNumber ref="fixtures"/>
        </v-tab-item>
        <v-tab-item>
          <Targets ref="targets"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Fixtures from '../components/ez_adas/Fixtures.vue';
import Targets from '../components/ez_adas/Targets.vue';

export default {
  components: {
    Fixtures,
    Targets,
  },

  data() {
    return {
      tab: 0,
      filterSerialNumber: '',
    };
  },

  methods: {
    refreshTab(tab) {
      if (this.$refs[tab]) {
        // this.$refs[tab].getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
